module.exports = __webpack_public_path__ + "img/20191118160900319.a519ce42.jpg";